import React, { useState, useEffect } from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { Flex } from '@goodrx/matisse';
import { CouponMini } from 'app/components/coupons';
import { Coupon } from 'app/types/Coupon';
import { ActionableMessage, ActionableMessageProps } from 'app/components/widgets/chat/message-types';

interface PrescriptionMessageProps extends ActionableMessageProps {
  scrollToBottom: () => void;
}

export const PrescriptionMessage: React.FC<PrescriptionMessageProps> = ({
  message,
  messageRef,
  scrollToBottom,
  onActionClick,
  ...props
}) => {
  const [fetchPrescriptionCoupon] = useSynapse(({ prescriptions }) => [prescriptions.fetchCoupon]);
  const [coupon, setCoupon] = useState<Coupon>();

  useEffect(() => {
    fetchPrescriptionCoupon(message.visitPrescriptionId).then(setCoupon).then(scrollToBottom);
  }, []);

  return (
    <Flex data-qa="prescription_message" flexDirection="column" ref={messageRef}>
      <ActionableMessage message={message} onActionClick={onActionClick} {...props} />

      {coupon?.visit && coupon.visit.shortCode && (
        <CouponMini
          mt={3}
          maxWidth="75%"
          coupon={coupon}
          visitShortCode={coupon.visit.shortCode}
          styles={{ couponCard: { borderRadius: 20 } }}
          visitPrescriptionId={message.visitPrescriptionId}
        />
      )}
    </Flex>
  );
};
